import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const getEmptyTeamMember = () => {
    return {
        name: "",
        designation: "None",
        batch: "",
        email: "",
        instagram: "",
        github: "",
        twitter: "",
        facebook: "",
        linkedin: "",
    };
};

function PersonsForm() {
    const [teamMember, setTeamMember] = useState(getEmptyTeamMember());
    const profile = useRef(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setTeamMember({
            ...teamMember,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("UnAuthorized");
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const formData = new FormData();
            for (const key in teamMember) {
                formData.append(key, teamMember[key]);
            }
            formData.append("profile", profile.current.files[0]);
            const response = await axios.post(
                `${BASE_URL}/persons`,
                formData,
                config
            );
            if (response.data.success === true) {
                alert("Team Member added successfully");
                navigate("/admin/team");
            } else {
                throw new Error(response.data.message);
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const handleReset = () => {
        setTeamMember(getEmptyTeamMember());
    };

    return (
        <div className="py-3 container is-fluid">
            <form encType="multipart/form-data">
                <div className="columns is-centered">
                    <div className="column is-two-thirds">
                        <div className="field">
                            <label className="label">Person Name</label>
                            <div className="control">
                                <input
                                    autoFocus
                                    name="name"
                                    className="input"
                                    value={teamMember.name}
                                    type="text"
                                    placeholder="Person Name"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Person Designation</label>
                            <div className="control">
                                <div className="select">
                                    <select
                                        defaultValue={teamMember.designation}
                                        onChange={handleChange}
                                        name="designation"
                                    >
                                        <option disabled value="None">
                                            None
                                        </option>
                                        <option value="General Secretary">
                                            General Secretary
                                        </option>
                                        <option value="Co-Secretary">
                                            Co-Secretary
                                        </option>
                                        <option value="Developer">
                                            Developer
                                        </option>
                                        <option value="Joint Secretary">
                                            Joint Secretary
                                        </option>
                                        <option value="Executive Member">
                                            Executive Member
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Batch</label>
                            <div className="control">
                                <input
                                    name="batch"
                                    className="input"
                                    type="text"
                                    value={teamMember.batch}
                                    placeholder="Ex. 2022-2023"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Person Profile</label>
                            <div className="control">
                                <input
                                    name="profile"
                                    className="input"
                                    type="file"
                                    ref={profile}
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Person Email</label>
                            <div className="control">
                                <input
                                    name="email"
                                    className="input"
                                    type="email"
                                    value={teamMember.email}
                                    placeholder="student@example.com"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Instagram</label>
                            <div className="control has-icons-left">
                                <input
                                    name="instagram"
                                    className="input"
                                    type="text"
                                    value={teamMember.instagram}
                                    placeholder="Instagram Username"
                                    onChange={handleChange}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fa-brands fa-instagram"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Github</label>
                            <div className="control has-icons-left">
                                <input
                                    name="github"
                                    className="input"
                                    type="text"
                                    value={teamMember.github}
                                    placeholder="Github Username"
                                    onChange={handleChange}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fa-brands fa-github"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Twitter</label>
                            <div className="control has-icons-left">
                                <input
                                    name="twitter"
                                    className="input"
                                    type="text"
                                    value={teamMember.twitter}
                                    placeholder="Twitter Username"
                                    onChange={handleChange}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fa-brands fa-twitter"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">FaceBook</label>
                            <div className="control has-icons-left">
                                <input
                                    name="facebook"
                                    className="input"
                                    type="text"
                                    value={teamMember.facebook}
                                    placeholder="Facebook Username"
                                    onChange={handleChange}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fa-brands fa-facebook"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Linkedin</label>
                            <div className="control has-icons-left">
                                <input
                                    name="linkedin"
                                    className="input"
                                    type="text"
                                    value={teamMember.linkedin}
                                    placeholder="Linkedin Username"
                                    onChange={handleChange}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fa-brands fa-linkedin"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field is-grouped">
                            <div className="control">
                                <button
                                    type="submit"
                                    className="button is-link is-success"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                            <div className="control">
                                <button
                                    type="reset"
                                    className="button is-link is-light is-danger"
                                    onClick={handleReset}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default PersonsForm;
